import { render } from "./AddBranch.vue?vue&type=template&id=94fa732a&scoped=true"
import script from "./AddBranch.vue?vue&type=script&lang=js"
export * from "./AddBranch.vue?vue&type=script&lang=js"

import "./AddBranch.vue?vue&type=style&index=0&id=94fa732a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94fa732a"]])

export default __exports__